import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  CheckBoxOptions, ControlLayout, DropdownOptions, FilterItem, FilterType,
  InputType, PagingOptions, TextAreaOptions, IconPosition ,TextBoxOptions, ImageUploadOptions, ImageType, MultiLingualTextBoxOptions, MultiLingualTextAreaOptions, EnglishArabicDTO
} from 'bnsights-control-library';
import { HelpCenterService } from '../../shared/Services/HelpCenterService.service';
import { HelpCenterItemModel } from '../../shared/models/HelpCenterModels/HelpCenterItemModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-help-center',
  templateUrl: './help-center.component.html'
})
export class HelpCenterComponent implements OnInit {
  ApiUrl = "/api/admin/HelpCenter/"
  // SubheaderTitle = this.utilityService.getResourceValue('HelpCenter');
  // ShowToolbar = true;
  // ShowbreadCrumb = false;
  searchTextBox: TextBoxOptions;
  PermissionSetsList = [];
  HelpCenterForm = new FormGroup({});
  showFilter: boolean = false;
  HelpCenterPagingResult: any[] = [];
  HelpCenterPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('HelpCenterPagingViewElement', { static: false }) input: ElementRef;

  language: string = ""
  ShowPageContent:boolean=false;
  //Add Model Controls
  AddHelpCenterForm = new FormGroup({});
  MultiLingualTitle:MultiLingualTextBoxOptions
  MultiLingualDescription:MultiLingualTextAreaOptions
  AddPermissionSetsOptions: DropdownOptions;
  AddIsHidden: CheckBoxOptions;
  AddLogo: ImageUploadOptions;
  IsAddHelpCenterFormLoaded: boolean = false;
  @ViewChild('CloseAddHelpCenterModal', { static: false }) CloseAddHelpCenterModal: ElementRef;

  //Edit Model Controls
  EditHelpCenterForm = new FormGroup({});
  EditMultiLingualTitle:MultiLingualTextBoxOptions
  EditMultiLingualDescription:MultiLingualTextAreaOptions
  EditPermissionSetsOptions: DropdownOptions;
  EditIsHidden: CheckBoxOptions;
  EditLogo: ImageUploadOptions;
  HelpCenterItemId: number;

  IsEditHelpCenterModalLoaded: boolean = false;
  @ViewChild('CloseEditHelpCenterModal', { static: false }) CloseEditHelpCenterModal: ElementRef;

  //delete  Model Controls
  deleteHelpCenterId: string;
  @ViewChild('CloseDeleteHelpCenterItemModal', { static: false }) CloseDeleteHelpCenterItemModal: ElementRef;

  //Generate code modal
  GenerateCodeForm = new FormGroup({});
  GeneratedCodeOptions: TextAreaOptions;
  @ViewChild('CloseGenerateCodeModal', { static: false }) CloseGenerateCodeModal: ElementRef;


  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private HelpCenterService: HelpCenterService, private modalService: NgbModal) {
  } 
   async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("HelpCenter")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    
    this.LoadList();
  }

 
  //initialize filters and load any drop down list
  LoadList() {
    this.HelpCenterService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.PermissionSetsList = DropdownLists.permissionSets;
       // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.searchTextBox.HideLabel = true,
      this.searchTextBox.Icon ="./src/assets/images/gen021.svg"
      this.searchTextBox.IconPosition = IconPosition.left


      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.HelpCenterPaging = new PagingOptions();
      this.HelpCenterPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetHelpCenterItemsByFilter';
      this.HelpCenterPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.HelpCenterPaging.Filters = [this.TextInputFilter]
      this.HelpCenterPaging.ValidationToken = this.authService.authorizationHeaderValue();
      this.IsFilterLoaded = true;

    })
  }



  ReinitializeHelpCenterPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateHelpCenterPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setHelpCenterItemListResult(result) {
    this.HelpCenterPagingResult = result;
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()

  }

  resetFilters() {
    this.HelpCenterForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddHelpCenterModal(AddHelpCenterModal){
    this.utilityService.startBlockUI();
    this.AddHelpCenterForm = new FormGroup({})
    this.MultiLingualTitle = new MultiLingualTextBoxOptions();
    this.MultiLingualTitle.Name = "Title";
    this.MultiLingualTitle.ArabicLabelKey =  "TitleInArabic";
    this.MultiLingualTitle.EnglishLabelKey = "TitleInEnglish";
    this.MultiLingualTitle.IsRequired = true;
    this.MultiLingualTitle.Value = null;
    this.MultiLingualDescription = new MultiLingualTextAreaOptions();
    this.MultiLingualDescription.Name = "Description";
    this.MultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.MultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";
    this.MultiLingualDescription.Value = null;
    this.MultiLingualDescription.MultiControlPlacementType = ControlLayout.Vertical;
    this.AddPermissionSetsOptions = new DropdownOptions();
    this.AddPermissionSetsOptions.Name = "AddPermissionSetsOptions"
    this.AddPermissionSetsOptions.LabelKey = "PermissionSets"
    this.AddPermissionSetsOptions.DataSource = this.PermissionSetsList
    this.AddPermissionSetsOptions.SingleSelection = false;
    this.AddPermissionSetsOptions.AllowSearchFilter = true;
    this.AddPermissionSetsOptions.Placeholder = "";
    this.AddPermissionSetsOptions.IsRequired = true;
    this.AddIsHidden = new CheckBoxOptions();
    this.AddIsHidden.Name = "AddIsHidden"
    this.AddIsHidden.LabelKey = "Hidden"
    this.AddIsHidden.Value = false
    this.AddLogo = new ImageUploadOptions();
    this.AddLogo.Name = "AddLogo"
    this.AddLogo.LabelKey = "Logo"
    this.AddLogo.ViewType = ControlLayout.Vertical
    this.AddLogo.FileUploadAcceptsTypes = [ImageType.ImageTypes]
    this.modalService.open(AddHelpCenterModal);
    this.utilityService.stopBlockUI();

}

  addHelpCenterItem() {
    if (this.AddHelpCenterForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddHelpCenterForm.value;
       //console.log(ResultModel);
      let AddModel:HelpCenterItemModel= new HelpCenterItemModel();
      AddModel.Title.Arabic = ResultModel.Title.ArabicValue;
      AddModel.Title.English = ResultModel.Title.EnglishValue;
      AddModel.Description.Arabic = ResultModel.Description.ArabicTextAreaValue;
      AddModel.Description.English = ResultModel.Description.EnglishTextAreaValue;
      let arr = ResultModel.AddPermissionSetsOptions;
      let permissionSets: number[] = [];
      const toNumbers = arr => arr.map(Number);
      permissionSets=toNumbers(arr);
      AddModel.PermissionSetIDs = ResultModel.AddPermissionSetsOptions != null ? permissionSets:null;
      AddModel.IsHidden = ResultModel.AddIsHidden;
      AddModel.LogoFileDTO = {
        FileBase64: ResultModel["AddLogo"].FileBase64,
        FileName: ResultModel["AddLogo"].FileName,
        FileSizeInMB: ResultModel["AddLogo"].FileSizeInMB,
        FileType: ResultModel["AddLogo"].FileType
      }


      this.HelpCenterService.AddHelpCenter(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      
      })
    }
  }
  showEditHelpCenterModal(HelpCenter: any, EditHelpCenterModal) {
    this.utilityService.startBlockUI()

    this.EditHelpCenterForm = new FormGroup({})
    this.HelpCenterItemId = HelpCenter.id

    let Title=new EnglishArabicDTO();
    Title.Arabic= HelpCenter.title.arabic;
    Title.English= HelpCenter.title.english;

    this.EditMultiLingualTitle = new MultiLingualTextBoxOptions();
    this.EditMultiLingualTitle.Name = "Title";
    this.EditMultiLingualTitle.ArabicLabelKey =  "TitleInArabic";
    this.EditMultiLingualTitle.EnglishLabelKey = "TitleInEnglish";
    this.EditMultiLingualTitle.IsRequired = true;
    this.EditMultiLingualTitle.Value = Title;
    this.EditMultiLingualTitle.Icon = "./src/assets/images/gen021.svg";
    this.EditMultiLingualTitle.IconPositionEN = IconPosition.left;
    this.EditMultiLingualTitle.IconPositionAR = IconPosition.right;

    let Description=new EnglishArabicDTO();
    Description.Arabic= HelpCenter.description.arabic;
    Description.English= HelpCenter.description.english;

    this.EditMultiLingualDescription = new MultiLingualTextAreaOptions();
    this.EditMultiLingualDescription.Name = "Description";
    this.EditMultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.EditMultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";
    this.EditMultiLingualDescription.Value = Description;
    this.EditMultiLingualDescription.MultiControlPlacementType = ControlLayout.Vertical;


   
    let selectedPermissionList = [];
    for (let index = 0; index < HelpCenter.permissionSetIDs.length; index++) {
      const Permission = this.PermissionSetsList.filter((item) => { return parseInt(item.key) == HelpCenter.permissionSetIDs[index]; }).map((item) => item.key)[0];
      selectedPermissionList.push(Permission);
    }
    this.EditPermissionSetsOptions = new DropdownOptions();
    this.EditPermissionSetsOptions.Name = "EditPermissionSetsOptions"
    this.EditPermissionSetsOptions.LabelKey = "PermissionSets"
    this.EditPermissionSetsOptions.DataSource = this.PermissionSetsList
    this.EditPermissionSetsOptions.SingleSelection = false;
    this.EditPermissionSetsOptions.AllowSearchFilter = true;
    this.EditPermissionSetsOptions.Placeholder = "";
    this.EditPermissionSetsOptions.SelectedItems = selectedPermissionList;

    this.EditIsHidden = new CheckBoxOptions();
    this.EditIsHidden.Name = "EditIsHidden"
    this.EditIsHidden.LabelKey = "Hidden"
    this.EditIsHidden.Value = HelpCenter.isHidden

    this.EditLogo = new ImageUploadOptions();
    this.EditLogo.Name = "EditLogo"
    this.EditLogo.LabelKey = "Logo"
    this.EditLogo.IsRequired = false
    this.EditLogo.FileUploadAcceptsTypes = [ImageType.ImageTypes]
    this.EditLogo.Value = HelpCenter.logoFileDTO

    
    this.modalService.open(EditHelpCenterModal);
    this.utilityService.stopBlockUI();


  }

  editHelpCenter() {
    if (this.EditHelpCenterForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditHelpCenterForm.value;
      let EditModel = new HelpCenterItemModel();
      EditModel.ID = Number(this.HelpCenterItemId);
      EditModel.Title.English = ResultModel.Title.EnglishValue; //(##1)
      EditModel.Title.Arabic = ResultModel.Title.ArabicValue;
      EditModel.Description.English = ResultModel.Description.EnglishTextAreaValue
      EditModel.Description.Arabic = ResultModel.Description.ArabicTextAreaValue
      EditModel.IsHidden = ResultModel.EditIsHidden;
      EditModel.LogoFileDTO = ResultModel.EditLogo;
      let Ids = [];
      for (let index = 0; index < ResultModel.EditPermissionSetsOptions.length; index++) {
        const element = ResultModel.EditPermissionSetsOptions[index];
        Ids.push(Number(element));
      }

      EditModel.PermissionSetIDs = Ids;

      this.HelpCenterService.EditHelpCenter(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
       
      })
    }
  }

  showDeleteHelpCenterModal(Item: any, deleteHelpCenterItemModal) {
    this.deleteHelpCenterId = Item.idEncrypted;
    this.utilityService.startBlockUI();
    this.modalService.open(deleteHelpCenterItemModal);
    this.utilityService.stopBlockUI();


  }

  deleteHelpCenter() {
    this.HelpCenterService.DeleteHelpCenter(this.deleteHelpCenterId).subscribe((result) => {
      this.deleteHelpCenterId = "";
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {

    })

  }

  SaveName(name) {
    localStorage.setItem("ParentName", name);
  }
  showGenerateCodeModal(GenerateCodeModal){

  this.HelpCenterService.GenerateCode().subscribe((result) => {
    let Code = result as any
    this.GeneratedCodeOptions = new TextAreaOptions();
    this.GeneratedCodeOptions.Name = "GeneratedCodeOptions";
    this.GeneratedCodeOptions.HideLabel = true;
    this.GeneratedCodeOptions.MaxLength = 1000000;
    this.GeneratedCodeOptions.Value = Code.text;
    this.GeneratedCodeOptions.EnableCopyToClipboard = true;
    this.GeneratedCodeOptions.AttributeList = [{ Key: "rows", value: "20" }];
    this.modalService.open(GenerateCodeModal);

  }, (error) => {
    
  })



}
}
